import Notice from '@bufferapp/ui/Notice'
import Text from '@bufferapp/ui/Text'
import styled from 'styled-components'

export const NoticeContainer = styled.div`
  padding: var(--space-xs) var(--space-lg) 0 var(--space-xs);
`

export const Container = styled.div`
  font-size: var(--font-size-body);
  line-height: var(--line-height-body);
  color: var(--color-text-neutral);
  border-color: var(--color-border-warning);
  padding: var(--space-xs) var(--space-sm) var(--space-xs) var(--space-sm);
  border-bottom-right-radius: var(--border-radius-sm);
  border-bottom-left-radius: var(--border-radius-sm);
  display: block;
  background-color: var(--color-bg-warning-subtle);
  margin-top: var(--space-sm);
  display: flex;
`

export const Item = styled(Text)`
  display: inline-flex;
`

export const IconContainer = styled.div`
  margin-right: var(--space-sm);
  top: var(--space-2xs);
  position: relative;
  color: var(--color-text-subtle);
  display: inline-flex;
`

export const ClickableIconContainer = styled(IconContainer)`
  &:hover {
    cursor: pointer;
  }
`

export const TwitterErrorContainer = styled(Notice)`
  margin: var(--space-sm) var(--space-sm) 0 var(--space-sm);
  padding: var(--space-xs);
  font-size: var(--font-size-caption);
  line-height: var(--line-height-caption);
  align-items: flex-start;

  svg {
    margin-right: var(--space-xs);
  }
`

export const CloseIconContainer = styled.div`
  cursor: pointer;
`

interface WarningWrapperProps {
  $maxHeight?: number
  $shouldBeVisible?: boolean
}
export const WarningWrapper = styled.div<WarningWrapperProps>`
  display: flex;
  padding: var(--space-xs) var(--space-md);
  gap: var(--space-xs);
  background: var(--color-bg-warning-subtle);
  color: var(--color-text-warning);
`

export const NoticeWrapper = styled.div<WarningWrapperProps>`
  display: flex;
  padding: var(--space-xs) var(--space-md);
  gap: var(--space-xs);
  background: var(--color-bg-subtle);
  color: var(--color-text-neutral);
`

interface HeightRefContainerProps {
  $maxHeight: number
  $shouldBeVisible?: boolean
}
export const HeightRefContainer = styled.div<HeightRefContainerProps>`
  overflow: hidden;
  max-height: ${(props): number => props.$maxHeight}px;
  opacity: ${(props): string => (props.$shouldBeVisible ? '1' : '0')};
  transition: max-height 400ms ease-in-out, opacity 400ms ease-in-out;
`

export const WarningIconWrapper = styled.span`
  margin-top: var(--space-xs);
`
